import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './css/GalleriesComponent3.css';
import { context } from '../../../../globalState/GlobalState';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import { getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { isValidString } from '../../../../catalog/Validity';
import { fetchGalleriesByTagAPI } from '../../../apiCalls/GalleryAPICalls';
import GalleryThumbnail2 from '../../galleryThumbnails/galleryThumbnail2/GalleryThumbnail2';
import PlaceholderComponent4 from '../../placeholderComponents/placeholderComponent4/PlaceholderComponent4';

const initialState = {
    galleries: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchGalleries':
            return { ...state, galleries: action.galleries };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const GalleriesComponent3 = (props) => {
    const { tagId, showTitle } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchArticles() {
            if (isValidString(globalState.accountId) && isValidString(tagId)) {
                setState({ type: 'setLoadingSpinner', loadingSpinner: true });
                await fetchGalleriesByTagAPI(globalState.accountId, tagId, setState, enqueueSnackbar);
                setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            }
        }
        fetchArticles();
    }, [globalState.accountId]);

    return (
        <div className="galleries-component3-container m-l-50px m-r-100px">
            {showTitle ? (
                <div className="galleries-component3-title p-t-20px p-r-20px p-b-20px p-l-20px" style={getOptimXBackgroundStyle(globalState)}>
                    <NavLink to="/galleries" className="galleries-component3-title-text font-size-5xl text-white m-l-20px m-t-0 m-b-0 text-uppercase text-no-underline">Galleries</NavLink>
                </div>
            ) : null}
            <div className="galleries-component3 full-width m-t-20px m-b-70px">
                {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                    <>
                        {state.galleries.length > 0 ? (
                            <>
                                {state.galleries.map((gallery) => {
                                    return (
                                        <div key={gallery.id} className="galleries-component3-gallery m-l-0 m-r-10px m-t-0 m-b-10px">
                                            <GalleryThumbnail2 gallery={gallery} />
                                        </div>
                                    );
                                })}
                            </>
                        ) : <PlaceholderComponent4 text="No Galleries Available" />}
                    </>
                )}
            </div>
        </div>
    );
};

GalleriesComponent3.propTypes = {
    tagId: PropTypes.string.isRequired,
    showTitle: PropTypes.bool,
};

GalleriesComponent3.defaultProps = {
    showTitle: true,
};

export default memo(GalleriesComponent3);
